var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "col-sm-12 col-md-12 col-xs-12" }, [
      _c("div", { staticClass: "virtual-tour-content" }, [
        _vm._v(
          " Learn about the features available within RAMS with a walk-through tutorial. "
        ),
      ]),
      _c(
        "button",
        {
          staticClass: "btn emergo-green-button tour-button",
          on: {
            click: function ($event) {
              return _vm.openTour()
            },
          },
        },
        [
          _c("img", {
            staticClass: "tour-icon",
            attrs: {
              src: "/static/images/icons/virtual_tour_white_icon.svg",
              alt: "tour-icon",
            },
          }),
          _c("span", { staticClass: "start-tour" }, [_vm._v("Start Tour")]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
      _c("hr"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }